import {useState} from 'react'
/* `id` lets another control open this one (details.open = true fires the same
 * toggle, so the lazy children render). */
export default function Disclosure({label,children,className,id}){
  const [visited,setVisited]=useState(false)
  return <details id={id} className={className} onToggle={event=>{if(event.currentTarget.open)setVisited(true)}}><summary>{label}</summary>{visited?children:null}</details>
}
